import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  root: css`
    width: 100%;
    border-top: 3px solid ${colors.silver};
    padding-bottom: 24px;
  `,
  item: css`
    border-bottom: 3px solid ${colors.silver};
  `,
  lastItem: css`
    &:last-child {
      border-bottom: none;
    }
  `,
  trigger: css`
    all: unset;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px 16px 24px;
    cursor: pointer;
    background-color: ${colors.white};
    color: ${colors.prussian};

    &:focus-visible {
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: -2px;
    }
  `,
  triggerExpanded: css`
    padding-bottom: 4px;
  `,
  triggerLabel: css`
    font-size: 18px;
    font-weight: 700;
    line-height: 1.4;
    color: ${colors.prussian};
    text-align: left;
  `,
  chevron: css`
    flex-shrink: 0;
    margin-left: 16px;
    color: ${colors.prussian};
    transition: transform 200ms ease;
  `,
  chevronExpanded: css`
    transform: rotate(180deg);
  `,
  panel: css`
    overflow: hidden;
    background-color: ${colors.white};
  `,
  panelInner: css`
    padding: 0 0px 24px;
  `,
};

export default styles;
